import { StateCreator } from "zustand";

export interface ServerTimeSlice {
  serverTime: string | null;
  serverTimeReceivedAt: number | null;
  setServerTime: (time: string | null) => void;
}

export const createServerTimeSlice: StateCreator<ServerTimeSlice> = (set) => ({
  serverTime: null,
  serverTimeReceivedAt: null,
  setServerTime: (time) =>
    set(() => ({
      serverTime: time,
      serverTimeReceivedAt: time ? Date.now() : null,
    })),
});
